import axiosClient from "./axiosClient";
import { API_ENDPOINTS, API_CREDENTIALS } from "./apiEndpoints";

export const fetchVenues = ({ venues_ids }) => {
  return axiosClient.get(API_ENDPOINTS.VENUES({ venues_ids }), {
    headers: {
      apikey: API_CREDENTIALS.API_KEY,
      "secure-business-key": API_CREDENTIALS.SECURE_BUSINESS_KEY,
      apiconnection: "appmobile",
      "Accept-Language": "en",
    },
  });
};
